import { FlowFormEntity } from './flowform.entity';
import { FormalParameterEntity } from './formal-parameter.entity';
import { BizComponentEntity } from './biz-component.entity';
import { ExcuteFormEntity } from './excute-form.entity';

export class FlowFormInfo {
    flowForm: FlowFormEntity;
    formalParameters: Array<FormalParameterEntity>;
    bizComponents: Array<BizComponentEntity>;
    excuteForms: Array<ExcuteFormEntity>;
    bizActivities: Array<any>;
    customizeActions: Array<any>;
}
